export default __webpack_public_path__ + "static/media/dwg-bg.8c9a3e60.png";